import { render, staticRenderFns } from "./HospitalSelectPage.vue?vue&type=template&id=52376312&scoped=true"
import script from "./HospitalSelectPage.vue?vue&type=script&lang=js"
export * from "./HospitalSelectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52376312",
  null
  
)

export default component.exports